import { useParams } from 'react-router-dom';
import { ClonePageProvider } from './ClonePageContext';
import type { ClonePageProps } from './ClonePageContext';
import { ClonePageSidebar } from './ClonePageSidebar';
import { DataTab } from './DataTab';
import { HistoryTab } from './HistoryTab';
import { OverviewTab } from './OverviewTab';
import type { ClonePageTab } from './types';

const componentByTabId = {
  overview: <OverviewTab />,
  data: <DataTab />,
  history: <HistoryTab />,
};

export const ClonePage = (props: ClonePageProps) => {
  const { tabId } = useParams<{ tabId: ClonePageTab }>();

  return (
    <ClonePageProvider {...props}>
      <div className="flex h-full w-full">
        <ClonePageSidebar />
        <div className="grow shrink-0">{tabId && componentByTabId[tabId]}</div>
      </div>
    </ClonePageProvider>
  );
};
